/**
 * Tronque un identifiant long pour l’affichage (préfixe + ellipsis).
 * Chaîne vide / nullish → `—`. Jusqu’à 12 caractères : affichage intégral.
 */
export function formatShortId(id: string | null | undefined): string {
  if (id == null || id === '') return '—';
  return id.length <= 12 ? id : `${id.slice(0, 8)}…`;
}
